// import {useRef} from  "react"
// import { Controller } from 'react-hook-form';
// import useSearch from '../hooks/useSearch';
// import FormInputField from '../../common/components/formElements/FormInputField';
// import FormDatePicker from '../../common/components/formElements/FormDatePicker';
// import FormComboBox from '../../common/components/formElements/FormComboBox';
// import { Link, useSearchParams } from 'react-router-dom';
// import imgsearch from './../../images/serch-icon.png';
// import { useEffect, useState } from 'react';
// import Select from 'react-select';
// import useSearchResults from '../../searchResults/hooks/useSearchResults';
// import axios from 'axios';

// const auxDate = new Date();
// const MIN_DATE = new Date(auxDate.setDate(auxDate.getDate() + 1));
// const API_BASE_URL = process.env.REACT_APP_API_SERVER;

// export default function Search() {
//     const specialtyRef = useRef(null); // 👈 f
//     const insuranceRefs = useRef(null);
//     const [searchParams] = useSearchParams();
//     const {
//         onSearch,
//         register,
//         handleSubmit,
//         control,
//         formError,
//         cities,
//         error,
//         getValues,
//         reset
//     } = useSearch();
//     const { getCurrentSearchParams } = useSearchResults();
//     const [specialities, setSpecialities] = useState([]);
//     const [insurances, setInsurances] = useState([]);
//     const handleSpecialtyClick = () => {
//         if (specialtyRef.current) {
//             specialtyRef.current.focus(); // 👈 triggers dropdown open
//         }
//     };
//     const handleInsuranceClick = () => {
//         if (insuranceRefs.current) {
//             insuranceRefs.current.focus(); // 👈 triggers dropdown open
//         }
//     }
//     useEffect(() => {
//         const { date, city, q,doctorName,insurance } = getCurrentSearchParams();
//         const selectCity = cities.find((item) => item.id.toString() === city);
//         reset({ specialty: q, city: selectCity, doctorName ,insurance });
//     }, [searchParams, cities]);

//     const getData = async () => {
//         try {
//           const [specialtyRes, insuranceRes] = await Promise.allSettled([
//             axios.get(`${API_BASE_URL}/specialty/getList`),
//             axios.get(`${API_BASE_URL}/insurance/getList`)
//           ]);

//           if (specialtyRes.status === "fulfilled") {
//             const formattedSpecialties = specialtyRes.value.data.map((item) => ({
//               value: item.id,
//               label: item.name
//             }));
//             setSpecialities(formattedSpecialties);
//           } else {
//             console.warn("Failed to fetch specialties:", specialtyRes.reason);
//           }

//           if (insuranceRes.status === "fulfilled") {
//             const formattedInsurance = insuranceRes.value.data.map((item) => ({
//               value: item.id,
//               label: item.name
//             }));
//             setInsurances(formattedInsurance);
//           } else {
//             console.warn("Failed to fetch insurance:", insuranceRes.reason);
//           }

//         } catch (error) {
//           console.error("Unexpected error:", error);
//         }
//       };

//     useEffect(() => {
//         getData();
//     }, []);

//     const customStyles = {
//         control: (styles, state) => ({
//           ...styles,
//           backgroundColor: 'transparent',
//           border: 'none',
//           boxShadow: 'none',
//           outline: 'none',
//           borderRadius: '8px',
//           '&:hover': {
//             border: 'none',
//           },
//         }),
//         option: (styles, { isDisabled, isFocused, isSelected }) => {
//           let backgroundColor = 'white';
//           let color = 'black';

//           if (isDisabled) {
//             backgroundColor = '#f0f0f0';
//             color = '#999';
//           } else if (isSelected) {
//             backgroundColor = '#3182ce';
//             color = 'white';
//           } else if (isFocused) {
//             backgroundColor = '#ebf8ff';
//             color = '#2b6cb0';
//           }

//           return {
//             ...styles,
//             backgroundColor,
//             color,
//             cursor: isDisabled ? 'not-allowed' : 'pointer',
//           };
//         },
//         indicatorSeparator: () => ({
//           display: 'none',
//         }),
//         dropdownIndicator: (styles) => ({
//           ...styles,
//           color: '#888',
//         }),
//         menu: (styles) => ({
//           ...styles,
//           zIndex: 9999,
//         }),
//       };

//     return (
//         <div className="bg-dl-screen-lightblue lg:px-8 mx-auto px-4 relative sm:px-6">
//             <div className="grid grid-cols-12 gap-12">
//                 <div className="col-span-12 md:col-span-12 search-box-top-main">
//                     <form onSubmit={handleSubmit(onSearch)} className="docter-link-form">
//                         {formError && (
//                             <p className="text-sm text-red-700 error-msge">
//                                 Debe llenar al menos un campo
//                             </p>
//                         )}
//                         {error !== '' && (
//                             <div className="mb-8 bg-blue-100 border-t-4 border-blue-500 rounded-b text-blue-900 px-4 py-3 shadow-md">
//                                 <div className="flex">
//                                     <div className="py-1">
//                                         <svg
//                                             className="fill-current h-6 w-6 text-blue-500 mr-4"
//                                             xmlns="http://www.w3.org/2000/svg"
//                                             viewBox="0 0 20 20"
//                                         >
//                                             <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
//                                         </svg>
//                                     </div>
//                                     <div>
//                                         <p className="font-bold mb-4">{error}</p>
//                                         <Link
//                                             to="/sign-in"
//                                             className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
//                                         >
//                                             Inicia sesión
//                                         </Link>
//                                     </div>
//                                 </div>
//                             </div>
//                         )}
//                         <div className="form-field-box-main w-90">
//                             <div className="field-1 form-field-box z-30">
//                                 <FormInputField
//                                     label="Nombre del Doctor"
//                                     type="text"
//                                     name="buscar"
//                                     id="buscar"
//                                     placeholder=""
//                                     registration={register('doctorName')}
//                                 />
//                             </div>

//                             <div
//                                 className="field-1 form-field-box !z-[99]"
//                                 onClick={handleSpecialtyClick}
//                                 style={{ cursor: 'pointer' }}
//                             >
//                                 {specialities.length > 0 ? (
//                                     <Controller
//                                         control={control}
//                                         name="specialty"
//                                         render={({ field }) => (
//                                             <>
//                                                 <label className="block mb-1 font-medium">Seleccione Especialidad</label>
//                                                 <Select
//                                                     ref={specialtyRef}
//                                                     options={specialities}
//                                                     isSearchable
//                                                     value={specialities.find(
//                                                         (option) => option.label === field.value || option.value === field.value
//                                                     )}
//                                                     onChange={(value) => field.onChange(value.label)}
//                                                     placeholder="Seleccione..."
//                                                     styles={customStyles}

//                                                 />
//                                             </>
//                                         )}
//                                     />
//                                 ) : (
//                                     <p>Loading specialties...</p>
//                                 )}
//                             </div>
//                             <div
//                                 className="field-1 form-field-box z-30"
//                                 onClick={handleInsuranceClick}
//                                 style={{ cursor: 'pointer' }}
//                             >
//                                 {insurances.length > 0 ? (
//                                     <Controller
//                                         control={control}
//                                         name="insurance"
//                                         render={({ field }) => (
//                                             <div>
//                                                 <label className="block mb-1 font-medium">Seleccione seguro compañía</label>
//                                                 <Select
//                                                     ref={insuranceRefs}
//                                                     options={insurances}
//                                                     isSearchable
//                                                     value={insurances.find(
//                                                         (option) => option.label === field.value || option.value === field.value
//                                                     )}
//                                                     onChange={(value) => field.onChange(value.label)}
//                                                     placeholder="Seleccione..."
//                                                     styles={customStyles}

//                                                 />
//                                             </div>
//                                         )}
//                                     />
//                                 ) : (
//                                     <p>Loading seguro... </p>
//                                 )}
//                             </div>

//                             <div className="field-2 form-field-box">
//                                 <Controller
//                                     control={control}
//                                     name="city"
//                                     render={({ field }) => (
//                                         <FormComboBox
//                                             label="Ciudad"
//                                             data={cities}
//                                             value={field.value}
//                                             onChange={(value) => field.onChange(value)}
//                                         />
//                                     )}
//                                 />
//                             </div>

//                             <div className="field-3 form-field-box">
//                                 <Controller
//                                     control={control}
//                                     name="date"
//                                     render={({ field }) => (
//                                         <FormDatePicker
//                                             identifier="date"
//                                             label="Fecha"
//                                             datePickerProps={{
//                                                 selected: field.value,
//                                                 dateFormat: 'dd/MM/yyyy',
//                                                 onChange: (date) => field.onChange(date),
//                                                 minDate: MIN_DATE,
//                                                 peekNextMonth: true,
//                                                 showMonthDropdown: true,
//                                                 showYearDropdown: false,
//                                                 dropdownMode: 'select'
//                                             }}
//                                         />
//                                     )}
//                                 />
//                             </div>

//                             <div className="search-btn-box">
//                                 <button type="submit" className="submit-btn">
//                                     <div>
//                                         <img
//                                             className="h-8 w-auto mr-1.5 flex justify-center"
//                                             src={imgsearch}
//                                             alt="DoctoLink"
//                                         />
//                                     </div>
//                                     Buscar
//                                 </button>
//                             </div>
//                         </div>
//                     </form>
//                 </div>
//             </div>
//         </div>
//     );
// }



import { useRef, forwardRef } from 'react'; 
import { Controller } from 'react-hook-form';
import useSearch from '../hooks/useSearch';
import FormInputField from '../../common/components/formElements/FormInputField';
import FormDatePicker from '../../common/components/formElements/FormDatePicker';
import FormComboBox from '../../common/components/formElements/FormComboBox';
import { Link, useSearchParams } from 'react-router-dom';
import imgsearch from './../../images/serch-icon.png';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import useSearchResults from '../../searchResults/hooks/useSearchResults';
import axios from 'axios';

const auxDate = new Date();
const MIN_DATE = new Date(auxDate.setDate(auxDate.getDate() + 1));
const API_BASE_URL = process.env.REACT_APP_API_SERVER;

export default function Search() {
    const specialtyRef = useRef(null);
    const insuranceRefs = useRef(null);
    const [searchParams] = useSearchParams();
    const { onSearch, register, handleSubmit, control, formError, cities, error, reset } = useSearch();
    const { getCurrentSearchParams } = useSearchResults();
    const [specialities, setSpecialities] = useState([]);
    const [insurances, setInsurances] = useState([]);

    const handleSpecialtyClick = () => {
        if (specialtyRef.current) {
            specialtyRef.current.focus();
        }
    };

    const handleInsuranceClick = () => {
        if (insuranceRefs.current) {
            insuranceRefs.current.focus();
        }
    };

    // 🔥 FIX: Refresh pe ya initial load pe form hamesha blank rahega
    useEffect(() => {
        reset({
            doctorName: '',
            specialty: null,
            insurance: null,
            city: null,
            date: null
        });
    }, [reset]);

    // Optional: Agar future mein results page se aane pe pre-fill karna ho to alag logic laga sakte ho
    // Abhi ke liye intentionally blank rakha hai

    const getData = async () => {
        try {
            const [specialtyRes, insuranceRes] = await Promise.allSettled([
                axios.get(`${API_BASE_URL}/specialty/getList`),
                axios.get(`${API_BASE_URL}/insurance/getList`)
            ]);

            if (specialtyRes.status === 'fulfilled') {
                const formattedSpecialties = specialtyRes.value.data
                    .map((item) => ({
                        value: item.id,
                        label: item.name
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label));
                setSpecialities(formattedSpecialties);
            }

            if (insuranceRes.status === 'fulfilled') {
                const formattedInsurance = insuranceRes.value.data
                    .map((item) => ({
                        value: item.id,
                        label: item.name
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label));
                setInsurances(formattedInsurance);
            }
        } catch (error) {
            console.error('Unexpected error:', error);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    const customStyles = {
        control: (styles) => ({
            ...styles,
            backgroundColor: 'transparent',
            border: 'none',
            boxShadow: 'none',
            outline: 'none',
            borderRadius: '8px',
            '&:hover': { border: 'none' }
        }),
        option: (styles, { isDisabled, isFocused, isSelected }) => {
            let backgroundColor = 'white';
            let color = 'black';

            if (isDisabled) {
                backgroundColor = '#f0f0f0';
                color = '#999';
            } else if (isSelected) {
                backgroundColor = '#3182ce';
                color = 'white';
            } else if (isFocused) {
                backgroundColor = '#ebf8ff';
                color = '#2b6cb0';
            }

            return {
                ...styles,
                backgroundColor,
                color,
                cursor: isDisabled ? 'not-allowed' : 'pointer'
            };
        },
        indicatorSeparator: () => ({ display: 'none' }),
        dropdownIndicator: (styles) => ({
            ...styles,
            color: '#888'
        }),
        menu: (styles) => ({
            ...styles,
            zIndex: 9999
        })
    };

    const onSubmit = (data) => {
        onSearch(data);

        // Search ke baad fields clear kar do
        setTimeout(() => {
            reset({
                doctorName: '',
                specialty: null,
                insurance: null,
                city: null,
                date: null
            });
        }, 0);
    };

    return (
        <div className="bg-dl-screen-lightblue lg:px-8 mx-auto px-4 relative sm:px-6">
            <div className="grid grid-cols-12 gap-12">
                <div className="col-span-12 md:col-span-12 search-box-top-main">
                    <form onSubmit={handleSubmit(onSubmit)} className="docter-link-form">
                        {formError && <p className="text-sm text-red-700 error-msge">Debe llenar al menos un campo</p>}
                        {error !== '' && (
                            <div className="mb-8 bg-blue-100 border-t-4 border-blue-500 rounded-b text-blue-900 px-4 py-3 shadow-md">
                                <div className="flex">
                                    <div className="py-1">
                                        <svg
                                            className="fill-current h-6 w-6 text-blue-500 mr-4"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                        >
                                            <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="font-bold mb-4">{error}</p>
                                        <Link
                                            to="/sign-in"
                                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                                        >
                                            Inicia sesión
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="form-field-box-main w-90">
                            <div className="field-1 form-field-box z-30">
                                <FormInputField
                                    label="Nombre del Doctor"
                                    type="text"
                                    name="buscar"
                                    id="buscar"
                                    placeholder=""
                                    registration={register('doctorName')}
                                />
                            </div>

                            <div
                                className="field-1 form-field-box !z-[99]"
                                onClick={handleSpecialtyClick}
                                style={{ cursor: 'pointer' }}
                            >
                                {specialities.length > 0 ? (
                                    <Controller
                                        control={control}
                                        name="specialty"
                                        render={({ field }) => (
                                            <>
                                                <label className="block mb-1 font-medium">
                                                    Seleccione Especialidad
                                                </label>
                                                <Select
                                                    ref={specialtyRef}
                                                    options={specialities}
                                                    isSearchable
                                                    value={
                                                        specialities.find((option) => option.label === field.value) ||
                                                        null
                                                    }
                                                    onChange={(option) => field.onChange(option ? option.label : null)}
                                                    placeholder="Seleccione..."
                                                    styles={customStyles}
                                                />
                                            </>
                                        )}
                                    />
                                ) : (
                                    <p>Loading specialties...</p>
                                )}
                            </div>

                            <div
                                className="field-1 form-field-box z-30"
                                onClick={handleInsuranceClick}
                                style={{ cursor: 'pointer' }}
                            >
                                {insurances.length > 0 ? (
                                    <Controller
                                        control={control}
                                        name="insurance"
                                        render={({ field }) => (
                                            <div>
                                                <label className="block mb-1 font-medium">
                                                    Seleccione seguro compañía
                                                </label>
                                                <Select
                                                    ref={insuranceRefs}
                                                    options={insurances}
                                                    isSearchable
                                                    value={
                                                        insurances.find((option) => option.label === field.value) ||
                                                        null
                                                    }
                                                    onChange={(option) => field.onChange(option ? option.label : null)}
                                                    placeholder="Seleccione..."
                                                    styles={customStyles}
                                                />
                                            </div>
                                        )}
                                    />
                                ) : (
                                    <p>Loading seguro... </p>
                                )}
                            </div>

                            <div className="field-2 form-field-box">
                                <Controller
                                    control={control}
                                    name="city"
                                    render={({ field }) => (
                                        <FormComboBox
                                            label="Ciudad"
                                            data={cities}
                                            value={field.value}
                                            onChange={(value) => field.onChange(value)}
                                        />
                                    )}
                                />
                            </div>

                            <div className="field-3 form-field-box">
                                <Controller
                                    control={control}
                                    name="date"
                                    render={({ field }) => (
                                        <div>
                                            <label className="flex items-center text-sm font-medium mb-1">
                                                Fecha
                                                <svg
                                                    className="h-4 w-4 text-gray-500 ml-1"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                                    />
                                                </svg>
                                            </label>

                                            <FormDatePicker
                                                identifier="date"
                                                label=""
                                                datePickerProps={{
                                                    selected: field.value,
                                                    dateFormat: 'dd/MM/yyyy',
                                                    onChange: (date) => field.onChange(date),
                                                    minDate: MIN_DATE,
                                                    peekNextMonth: true,
                                                    showMonthDropdown: true,
                                                    showYearDropdown: false,
                                                    dropdownMode: 'select',

                                                    onKeyDown: (e) => e.preventDefault(),
                                                    onPaste: (e) => e.preventDefault(),
                                                    onChangeRaw: (e) => e.preventDefault()
                                                }}
                                            />
                                        </div>
                                    )}
                                />
                            </div>

                            <div className="search-btn-box">
                                <button type="submit" className="submit-btn">
                                    <div>
                                        <img
                                            className="h-8 w-auto mr-1.5 flex justify-center"
                                            src={imgsearch}
                                            alt="DoctoLink"
                                        />
                                    </div>
                                    Buscar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
